export default __webpack_public_path__ + "static/media/mailLogo.b2e4bfd9.svg";